<template>
  <div v-if="result.objekt.searching && !result.objekt.updating" class="content-container custom-scrollbar">
    <TheLoader :active="true" :update="false"/>
  </div>

  <div v-else-if="result.objekt.total < 1" class="content-container custom-scrollbar">
    <div class="center-container" >
      <div class="center-content">
        <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-search"></use></svg></div>
        <h2 class="bold">Fant ingen treff</h2>
        <p>Søket returnerte ingen treff. <br>Prøv på nytt med et annet søkeord.</p>
      </div>
    </div>
  </div>

  <div v-else id="result-content" class="content-container content-x-scroll custom-scrollbar os-theme-dark search-scroll">
  <!-- <overlay-scrollbars id="result-content" v-else :options="{ className: 'content-container content-x-scroll custom-scrollbar os-theme-dark search-scroll', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }"> -->
    <TheLoader :active="result.objekt.updating" :update="true"/>
    <table id="advanced-results-table" class="large fixed sortable clickable table-filter sticky-table-header sticky-table-first-column" :class="listTypeClass">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th v-for="(heading, index) in userHeadings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === result.objekt.sort.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
          <span v-if="heading.name === 'Tekst_ok'">Objekt</span>
          <span v-else-if="heading.name === 'Fototatt'">Foto</span>
          <span v-else-if="heading.name === 'Bet_dato'">Betalt</span>
          <span v-else-if="heading.name === 'Lev_dato'">Utlevert</span>
          <span v-else-if="heading.name === 'oppgjor_dato'">Oppgjørsdato</span>
          <span v-else-if="heading.name === 'oppgjor_belop'">Oppgjørsbelop</span>
          <span v-else>{{heading.name}}</span>
          <span id="sorttable_sortrevind" v-if="heading.sortKey === result.objekt.sort.sort && result.objekt.sort.direction === 'desc'">&nbsp;</span>
          <span id="sorttable_sortfwdind" v-if="heading.sortKey === result.objekt.sort.sort && result.objekt.sort.direction === 'asc'">&nbsp;</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in result.objekt.items" v-bind:key="item.Objektid">
        <td class="context-menu">
          <a href="javascript:;" @click="onRowMenuClick($event, item)" class="button action glyph-only small"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg> <span>Settings</span></a>
        </td>
        <td v-for="(col, index) in item.cols" v-bind:key="item.id + '.' + index" @click="onRowClick(item)" :class="col.cls">
          <template v-if="col.key === 'Bilde'">
            <span class="object-image-column hover-card-trigger" data-hc-id="hover-card-search">
              <div class="flex-container">
                <span class="thumbnail-container">
                  <span class="thumbnail small" @mouseenter="hover($event, item)" @mouseleave="hoverOff($event)">
                    <template v-if="col.val && col.val.thumb && col.val.thumb.length > 0">
                      <img :src="objektThumb(item.Objektnr, col.val)"/>
                    </template>
                    <template v-else>
                      <v-lazy-image :src="objektThumb(item.Objektnr, col.val)" @load="objektThumbLoaded(item)"/>
                      <span class="placeholder"></span>
                    </template>
                  </span>
                </span>
              </div>
            </span>
          </template>
          <template v-else-if="col.key === 'Kontraktansvarlig'">
            <span v-if="col.val" :title="col.val.full_name">{{col.val.Brukernavn}}</span>
            <span v-else>-</span>
          </template>
          <template v-else-if="col.bool">
            <span v-if="col.val" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
            <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
          </template>
          <template v-else><span :title="col.val">{{col.val}}</span></template>
        </td>
      </tr>
    </tbody>
    </table>

    <span id="objekt-popover" class="button-container has-popover" :class="{'popover-active': objektPopoverItem}">
      <span v-if="objektPopoverItem" class="popover align-x-left align-y-bottom large" style="display:flex; width: 350px;" >
        <ul>
          <li><a :href="objektPopoverItem.objektLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg> <span>Vis objekt</span></a></li>
          <li><a :href="objektPopoverItem.kontraktLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
          <li :class="{'disabled' : !objektPopoverItem.Buyer}"><a :href="objektPopoverItem.kjoperLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis Kjøper</span></a></li>
          <li :class="{'disabled' : !objektPopoverItem.Kundenr}"><a :href="objektPopoverItem.kundeLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis selger</span></a></li>
          <li v-if="objektPopoverItem.Kunstner"><a @click="openKunstnerObjektListModal(objektPopoverItem.Kunstner)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg> <span>Kunstnerens objekter</span></a></li>
        </ul>
        <span>
          <div class="data-grid">
            <div class="grid-x grid-padding-x grid-padding-small hover-card active" style="width:245px; position: relative;">
              <div class="cell border-bottom hover-card-header" style="padding-bottom: 1rem;padding-top: 1rem;">
                <span class="hover-card-content">
                  <span class="item-title">
                    <span class="title data-hc-title">{{objektPopoverItem.Title}}</span>
                    <span class="subtitle data-hc-subtitle">{{objektPopoverItem.Objektnr}}</span>
                    <span class="subtitle data-hc-count">Antall: {{objektPopoverItem.Antall || '-'}}</span>
                  </span>
                </span>
              </div>

              <div class="cell large-6 border-bottom">
                <div class="dl-wrap">
                  <span class="dl dt">Lav vurdering</span>
                  <span class="dl dd data-hc-price-low">{{objektPopoverItem.VurderingLow}}</span>
                </div>
              </div>

              <div class="cell large-6 border-bottom">
                <div class="dl-wrap">
                  <span class="dl dt">Høy vurdering</span>
                  <span class="dl dd data-hc-price-high">{{objektPopoverItem.VurderingHigh}}</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Minstepris</span>
                  <span class="dl dd data-hc-price-min">{{objektPopoverItem.Minstepris}}</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Tilslag</span>
                  <span class="dl dd data-hc-sold">{{objektPopoverItem.Tilslag}}</span>
                </div>
              </div>
            </div>
          </div>
        </span>
      </span>
    </span>

    <div class="pagination-container" v-if="result.objekt.pages > 1">
      <paginate
        v-model="result.objekt.page"
        :page-count="result.objekt.pages"
        :page-range="3"
        :click-handler="changePage"
        :container-class="'pagination'"
        :prev-text="paginationArrow"
        :next-text="paginationArrow"
        :prev-class="'prev'"
        :next-class="'next'"
        >
      </paginate>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'TheMainSearchAdvancedResult',
  props: {
    result: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    settings: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      objektPopoverItem: null,
      headings: [
        {name: 'Bilde', sortKey: '', class: 'object-image-column unsortable'},
        {name: 'Objektnr', sortKey: 'Objektnr', class: ''},
        {name: 'Auksjonsdato', sortKey: 'auksjonsdato', class: ''},
        {name: 'Kunstner', sortKey: 'kunstner.Navn.sort', class: ''},
        {name: 'Tittel', sortKey: 'Katalogtekst1.sort', class: ''},
        {name: 'Beskrivelse', sortKey: 'Objekt3.sort', class: ''},
        {name: 'Tekst', sortKey: 'Katalogtekst2.sort', class: ''},
        {name: 'Tilslag', sortKey: 'salgspris_sort', class: 'align-right'},
        {name: 'Vurdering', sortKey: 'Vurderingspris', class: 'align-right'},
        {name: 'Minstepris', sortKey: 'Minstepris', class: 'align-right'},
        {name: 'Signert', sortKey: 'Objekt1.sort', class: ''},
        {name: 'Lokasjon', sortKey: 'lokasjon.Beskrivelse.sort', class: ''},
        {name: 'Hentet', sortKey: 'Lev_dato', class: ''},
        {name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: ''},
        {name: 'Type', sortKey: 'Objekttype', class: ''},
        {name: 'Katalognr', sortKey: 'Katalognr', class: ''},
        // {name: 'Bnr.', sortKey: 'Katbnr', class: ''},
        {name: 'Registrert dato', sortKey: 'Registrert_dato', class: ''},
        {name: 'Relevans', sortKey: '_score', class: 'align-right'},
        {name: 'Tekst_ok', sortKey: 'Tekst_ok', class: ''},
        {name: 'Fototatt', sortKey: 'Fototatt', class: ''},
        {name: 'Bet_dato', sortKey: 'Bet_dato', class: ''},
        {name: 'Lev_dato', sortKey: 'Lev_dato', class: ''},
        {name: 'Fakturert', sortKey: 'Fakturert', class: ''},
        {name: 'oppgjor_dato', sortKey: 'oppgjor_dato', class: ''},
        {name: 'oppgjor_belop', sortKey: 'oppgjor_belop', class: 'align-right'},
        {name: 'Kontraktansvarlig', sortKey: 'kontraktsansvarlig.Brukernavn', class: 'align-right'}
      ]
    }
  },
  computed: {
    userHeadings: function () {
      let retval = []

      this.settings.columns.forEach((item) => {
        // Must be true || check override of bilde col
        if (item.value && !(item.name === 'Bilde' && this.settings.listtype === 'none')) {
          let found = this.headings.findIndex(x => x.name === item.name)

          if (found !== -1) {
            retval.push(this.headings[found])
          }
        }
      })

      return retval
    },
    sortClass: function () {
      return 'sorttable_sorted' + (this.result.objekt.direction !== 'asc' ? '_reverse' : '')
    },
    listTypeClass: function () {
      if (this.settings.listtype === 'none') {
        return 'search-thumbnails-none'
      }

      if (this.settings.listtype === 'large') {
        return 'search-thumbnails-large'
      }

      return 'search-thumbnails-small'
    }
  },
  methods: {
    hoverOff: function (evt) {
      bus.$emit('hover-image', {
        imageUrl: '',
        event: null
      })
    },
    hover: function (evt, item) {
      bus.$emit('hover-image', {
        imageUrl: process.env.VUE_APP_AVANTI_API_URL + '/objekt/photo.json?objektnr=' + item.Objektnr + '&size=large',
        event: evt
      })
    },
    changePage: function (p) {
      if (isNaN(p)) {
        return
      }

      window.jQuery('#result-content').animate({
        scrollTop: 0
      }, 200, function () {
        bus.$emit('change-advanced-page', p)
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      window.jQuery('#result-content').animate({
        scrollTop: 0
      }, 200, function () {
        bus.$emit('change-advanced-sort', sortKey)
      })
    },
    objektThumb: function (objektnr, value) {
      if (value.thumb && value.thumb.length > 0) {
        return value.thumb[0]
      }

      return null
    },
    objektThumbLoaded: function (item) {
      const found = item.cols.findIndex(x => x.key === 'Fototatt')
      if (found !== -1) {
        item.cols[found].val = true
      }
    },
    openKunstnerObjektListModal: function (item) {
      console.log('Kunstner modal')
      console.log(item)
      if (item) {
        console.log('do open')
        this.openModal('kunstner-objekt-list-modal', { kunstner: item, internalWindow: true }, 'large')
      }
    },
    onRowClick: function (item) {
      if (this.objektPopoverItem) {
        this.objektPopoverItem = null
      } else {
        bus.$emit('before-leave-page')

        this.$router.push({
          path: '/searchredirect',
          query: { kunde_id: item.Kundenr, kontrakt: item.Kontraktnr, objekt: item.Objektid },
          hash: ''
        })
      }
    },
    onRowMenuClick: function (evt, item) {
      if (this.objektPopoverItem) {
        this.objektPopoverItem = null
      } else {
        window.jQuery('#objekt-popover').css({
          position: 'absolute',
          margin: 0,
          left: '22px', // evt.pageX + 40,
          top: evt.pageY - 47,
          width: '350px'
        })

        this.objektPopoverItem = item

        // Make links
        this.objektPopoverItem.objektLink = '/kunde/' + item.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid + '&searchResult=true&advanced=true'
        this.objektPopoverItem.kontraktLink = '/kunde/' + item.Kundenr + '?kontrakt=' + item.Kontraktnr + '&searchResult=true&advanced=true'
        this.objektPopoverItem.kundeLink = item.Kundenr
        this.objektPopoverItem.kjoperLink = item.Buyer ? '/kunde/' + item.Buyer.Kundenr : 'javascript:;'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchAdvancedResult.vue